import { getSitemap } from "../../api/sitemap";
import { DirectoryPageLayout } from "../../pagelayouts/directory";
const { XMLParser } = require('fast-xml-parser');

const DirectoryPage = ({ links, letter }: { links: string[], letter: string }) => {
    return <DirectoryPageLayout links={links} letter={letter} />
}

export async function getStaticPaths() {
    const alphabet = 'abcdefghijklmnopqrstuvwxyz'.split('');
    const paths = alphabet.map((letter) => ({ params: { letter } }));
    return { paths, fallback: false }
}

export async function getStaticProps(ctx: any) {
    const letter = ctx.params.letter as string;
    const data = await getSitemap(letter);
    const parser = new XMLParser();
    const jObj = parser.parse(data);

    return {
        props: {
            links: Array.isArray(jObj.urlset.url) ? jObj.urlset.url.map((url: { loc: string; }) => url.loc) : jObj.urlset.url ? [jObj.urlset.url.loc] : [],
            letter
        },
        revalidate: 86400
    }
}

export default DirectoryPage